const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.SEMI_PRODUCT)

export const apiSemiProducts = {
	fetchDietSemiProducts: async (
		tags: string[] | undefined,
		diets: string[] | undefined,
		search: string | undefined,
		page: number = 1,
		perPage: number = 25,
	): Promise<{ data: IDietSemiProductModel[]; meta: IApiMetaModel | undefined }> => {
		const { data, meta } = await apiCommon<IDietSemiProduct[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }, { name: search, tags, diets }),
		})

		return { data: data.map(d => DietSemiProduct(d)), meta }
	},
	fetchDietSemiProductDetails: async (id: number): Promise<IDietSemiProductDetailsModel> => {
		const { data } = await apiCommon<IDietSemiProductDetails>(`${groupPrefix}/${id}`, {
			method: 'GET',
		})

		return DietSemiProductDetails(data)
	},
	createDietSemiProduct: async (payload: IDietSemiProductCreatePayload): Promise<IDietSemiProductModel> => {
		const { data } = await apiCommon<IDietSemiProduct>(`${groupPrefix}`, {
			method: 'POST',
			body: payload,
		})

		return DietSemiProduct(data)
	},
	updateDietSemiProduct: async (payload: IDietSemiProductUpdatePayload): Promise<IDietSemiProductModel> => {
		const { data } = await apiCommon<IDietSemiProduct>(`${groupPrefix}/${payload.id}`, {
			method: 'PUT',
			body: payload,
		})

		return DietSemiProduct(data)
	},
	deleteDietSemiProduct: async (id: number): Promise<void> => {
		await apiCommon(`${groupPrefix}/${id}`, { method: 'DELETE' })
	},
	duplicateDietSemiProduct: async (id: number): Promise<IDietSemiProductModel> => {
		const { data } = await apiCommon<IDietSemiProduct>(`${groupPrefix}/${id}/duplicate`, { method: 'POST' })

		return DietSemiProduct(data)
	},
	fetchDietSemiProductProductionSteps: async (id: number): Promise<IDietProductionStepModel[]> => {
		const { data } = await apiCommon<IDietProductionStep[]>(`${groupPrefix}/${id}/production-stages`, {
			method: 'GET',
		})

		return data.map(item => DietProductionStep(item))
	},
	fetchDietSemiProductHistory: async (
		id: number,
		page: number = 1,
		perPage: number = 25,
	): Promise<IApiResponseModel<IDietSemiProductHistoryModel[]>> => {
		const { data, meta } = await apiCommon<IDietSemiProductHistory[]>(`${groupPrefix}/${id}/edit-history`, {
			method: 'GET',
			...createQuery({ page, perPage }),
		})

		return { data: data.map(item => DietSemiProductHistory(item)), meta }
	},
}
